// extracted by mini-css-extract-plugin
export default {"container":"f_-z","list":"g_-z"};